var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 48.5H53C53.913 48.49 54.342 48.5 54.921 48.5C55.5 48.5 56.2 46.92 54.5 45.5L50.5 42V36",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 36.5V32.5M11.5 20.5V18.44C11.488 17.4 11.926 16.397 12.716 15.657C13.506 14.917 14.582 14.5 15.706 14.5H46.295C47.395 14.4916 48.4577 14.8983 49.271 15.639C50.061 16.37 50.502 17.363 50.5 18.397V20.5H11.5Z",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 32V35.5",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 45.5H35.5M14.5 42.5H47.5H14.5Z",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 35.5V42L8.10599 45.522C7.81303 45.8031 7.61416 46.1679 7.53664 46.5664C7.45912 46.9649 7.50674 47.3776 7.67299 47.748C8.01399 48.505 8.60299 48.51 9.46599 48.498H36.5",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48.5H51",
    stroke: "#E1C078",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 29.5H8.5M6 24.5H17H6ZM11.5 29.5H16.5H11.5Z",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22L37 27M46.5 24.5H52.5H46.5ZM54.5 24.5H57.5H54.5ZM51.5 28.5H61.5H51.5ZM46.5 32.5H55.5H46.5ZM24.707 35.5L22 27.674L40 27.5L37.293 35.5H24.707ZM28.5 22L24.44 26.68L28.5 22Z",
    stroke: "#C6A760",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder1);
export default __webpack_public_path__ + "static/media/order 1.26b3720f212ccf0d9fbe6ade46eb58ce.svg";
export { ForwardRef as ReactComponent };